<template>
    <MobileTopBar :with_logo="true"/>
    <div class="container">
        <div class="mb-5 md:mb-10">
            <HomeTopComponent/>
            <OnlyDesktop>
                <CompanyAdvantages/>
            </OnlyDesktop>
        </div>
    </div>
    <div class="container">
        <div class="mb-10">
            <PopularProductBanners/>
        </div>
    </div>
    <div class="container">
        <div class="mb-10">
            <SearchByPhotoBanner/>
        </div>
    </div>
    <div class="max-md:ps-5 sm:container">
        <div class="mb-10">
            <PopularCollectionsSlider/>
        </div>
    </div>
    <div class="container">
        <div class="mb-10">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <FigureChoice/>
                <ColorChoice/>
            </div>
        </div>
    </div>
    <div class="max-md:ps-5 sm:container">
        <div class="mb-10">
            <h2 class="text-2xl font-semibold mb-6">
                Услуги для бизнеса
            </h2>
            <B2BSlider/>
        </div>
    </div>
    <div class="max-md:ps-5 sm:container">
        <div class="mb-10">
            <PopularBrandSlider/>
        </div>
    </div>
</template>

<script>
import HomeTopComponent from "@js/components/Sections/Home/HomeTopComponent.vue";
import CompanyAdvantages from "@js/components/Sections/Home/CompanyAdvantages.vue";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import PopularBrandSlider from "@js/components/Sliders/PopularBrandSlider.vue";
import PopularCollectionsSlider from "@js/components/Sliders/PopularCollectionsSlider.vue";
import FigureChoice from "@js/components/Sections/Home/FigureChoice.vue";
import ColorChoice from "@js/components/Sections/Home/ColorChoice.vue";
import SearchByPhotoBanner from "@js/components/Sections/Home/SearchByPhotoBanner.vue";
import B2BSlider from "@js/components/Sections/B2B/B2BSlider.vue";
import PopularProductBanners from "@js/components/Sections/Home/PopularProductBanners.vue";

export default {
    name: 'Home',
    components: {
        PopularProductBanners,
        B2BSlider,
        SearchByPhotoBanner,
        ColorChoice,
        FigureChoice,
        PopularCollectionsSlider,
        PopularBrandSlider,
        MobileTopBar,
        OnlyDesktop,
        CompanyAdvantages,
        HomeTopComponent
    },
    data() {
        return {};
    },
    beforeMount() {
    },
    setup() {

    },
    mounted() {
        this.isMounted = true
    }
};
</script>

<style lang="scss">

</style>
